export type HomeCause = {
  cause: string;
  probability: number;
};

export type HomeFault = {
  id: string;
  category_id: string | null;
  device_ar: string;
  name_ar: string;
  description_ar: string;
  symptoms: string[];
  causes: HomeCause[];
  tests: {
    test: string;
    location: string;
    method: string;
    normal: string;
    faulty: string;
  }[];
  solutions: string[];
  severity: string;
  safety_warnings: string[];
  error_code: string | null;
  keywords: string;
  next_question_key: string | null;
};

type Row = [
  string,
  string,
  string,
  string,
  string,
  HomeCause[],
  string[],
  string,
  string,
  string
];

const C = (
  cause: string,
  probability: number,
): HomeCause => ({
  cause,
  probability,
});

const rows: Row[] = [
  [
    "home-001",
    "التغذية الرئيسية",
    "الكهرباء طافية من البيت كله",
    "ماكو كهرباء بأي مكان بالبيت، لا إنارة ولا بلكات سويج تشتغل.",
    "البيت كله بدون كهرباء",
    [
      C("الكهرباء مقطوعة من المصدر", 45),
      C("القاطع الرئيسي فاصل", 35),
      C("أكو خلل بكابل الدخول أو الفيوز الرئيسي", 20),
    ],
    [
      "تأكد أول شي إذا الكهرباء موجودة بالمنطقة.",
      "إذا المشكلة من داخل البيت، خلي فني يفحص القاطع الرئيسي والتغذية.",
    ],
    "عالية",
    "انقطاع كهرباء كامل البيت main power outage",
    "تأكد من القاطع الرئيسي ومن وجود أي آثار حرارة أو احتراق، بس لا تفتح اللوحة إذا ما عندك خبرة.",
  ],

  [
    "home-002",
    "التغذية الرئيسية",
    "الكهرباء طافية من قسم من البيت",
    "بعض الغرف بيها كهرباء وبعضها لا، أو مجموعة بلكات سويج وإنارة متوقفة.",
    "قسم من البيت بدون كهرباء",
    [
      C("قاطع فرعي فاصل", 50),
      C("أكو وصلة مرخية أو محترقة", 30),
      C("أكو سلك مقطوع يغذي هالقسم", 20),
    ],
    [
      "حدد شنو الغرف أو النقاط اللي ما تشتغل.",
      "افحص القاطع الفرعي، وإذا يرجع يفصل خلي فني يفحص الدائرة.",
    ],
    "متوسطة",
    "جزء من البيت بدون كهرباء partial outage",
    "بعد فصل الكهرباء، ينفحص القاطع والتمديدات الخاصة بالقسم المتأثر.",
  ],

  [
    "home-003",
    "القاطع الرئيسي",
    "القاطع الرئيسي يفصل من أشغل هواية أجهزة",
    "من تشغل أكثر من جهاز قوي بنفس الوقت، القاطع الرئيسي يفصل.",
    "القاطع يفصل ويا الأحمال العالية",
    [
      C("الحمل على البيت أعلى من تحمل القاطع", 55),
      C("أكو وصلة رئيسية مرخية", 25),
      C("القاطع قديم أو تعبان", 20),
    ],
    [
      "جرب تقلل الأجهزة القوية اللي تشتغل بنفس الوقت.",
      "إذا استمر الفصل، يحتاج فحص الحمل والقاطع.",
    ],
    "عالية",
    "main breaker overload قاطع رئيسي يفصل",
    "لا تبدل القاطع بأمبير أعلى من نفسك. لازم فني يتأكد من الكيبل والحمل أولاً.",
  ],

  [
    "home-004",
    "القاطع الرئيسي",
    "حرارة القاطع الرئيسي ترتفع",
    "تحس القاطع الرئيسي حرارته مرتفعة بشكل مو طبيعي أو تشم ريحة حرك يم اللوحة.",
    "ارتفاع حرارة القاطع الرئيسي",
    [
      C("أكو ربط مرخي", 50),
      C("الحمل عالي لفترة طويلة", 30),
      C("القاطع نفسه بيه عطل", 20),
    ],
    [
      "قلل الأحمال وخلي القاطع مفصول إذا الحرارة قوية.",
      "خلي فني يفحص الربطات والقاطع.",
    ],
    "حرجة",
    "قاطع رئيسي حرارة عالية main breaker overheating",
    "إذا أكو حرك أو ذوبان أو ريحة قوية، لا ترجع الكهرباء قبل الفحص.",
  ],

  [
    "home-005",
    "القاطع الفرعي MCB",
    "القاطع يفصل فوراً من أرفعه",
    "من تحاول ترفع القاطع، مباشرة يرجع يفصل.",
    "القاطع ما يبقى شغال",
    [
      C("أكو شورت بالدائرة", 55),
      C("أكو تسريب أرضي", 25),
      C("القاطع نفسه خربان", 20),
    ],
    [
      "لا تبقى تعيد رفع القاطع كل شوي.",
      "افصل الأجهزة من الدائرة وجرب تحدد الجهاز أو الخط المسبب.",
    ],
    "عالية",
    "MCB يفصل فوراً short circuit breaker",
    "إذا القاطع يفصل وهو ماكو أجهزة مربوطة، خلي الدائرة مفصولة وخلي فني يفحصها.",
  ],

  [
    "home-006",
    "القاطع الفرعي MCB",
    "القاطع يفصل بعد فترة من التشغيل",
    "كلشي يشتغل طبيعي بالبداية، وبعد كم دقيقة القاطع يفصل.",
    "الفصل يصير بعد شوية",
    [
      C("الحمل زايد على الدائرة", 55),
      C("أكو ربطة مرخية ترتفع حرارتها", 25),
      C("القاطع ضعيف أو تعبان", 20),
    ],
    [
      "قلل الأجهزة المربوطة على نفس الخط.",
      "إذا استمر، لازم تنفحص الربطات والقاطع.",
    ],
    "عالية",
    "قاطع يفصل بعد دقائق thermal trip overload",
    "إذا تشوف حرارة عالية أو اسوداد ببلك السويج أو القاطع، وقف الاستخدام فوراً.",
  ],

  [
    "home-007",
    "القاطع الفرعي MCB",
    "القاطع ما يقبل يثبت",
    "تحاول ترفعه بس ما يبقى على وضع التشغيل.",
    "القاطع ما يثبت على ON",
    [
      C("أكو شورت أو تسريب مستمر", 55),
      C("جهاز خربان بعده مربوط", 25),
      C("القاطع نفسه خربان", 20),
    ],
    [
      "افصل الأجهزة كلها من هالدائرة.",
      "إذا بعده ما يثبت، خلي فني يفحص الخط.",
    ],
    "عالية",
    "MCB لا يقبل الرفع breaker will not reset",
    "لا تجبر القاطع على التشغيل ولا تثبته بأي طريقة.",
  ],

  [
    "home-008",
    "قاطع التسريب RCCB",
    "قاطع التسريب يفصل كل شوي",
    "قاطع الحماية من التسريب يفصل بشكل متكرر أو من تشغل جهاز معين.",
    "RCCB يفصل باستمرار",
    [
      C("أكو جهاز يسرب كهرباء", 45),
      C("أكو رطوبة أو ضعف بالعزل", 30),
      C("النيوترال (البارد) لامس الأرضي", 15),
      C("قاطع RCCB نفسه خربان", 10),
    ],
    [
      "افصل الأجهزة واحد واحد حتى تعرف شنو المسبب.",
      "لا تلغي قاطع التسريب ولا تتجاوزه.",
    ],
    "حرجة",
    "RCCB RCD يفصل تسريب ارضي",
    "قاطع التسريب حماية مهمة جداً. إذا يفصل، أكو احتمال صعقة كهربائية ولازم السبب ينفحص.",
  ],

  [
    "home-009",
    "قاطع التسريب RCCB",
    "قاطع التسريب ما يقبل يثبت",
    "تحاول تشغله بس يرجع يفصل وما يبقى شغال.",
    "RCCB ما يبقى ON",
    [
      C("أكو تسريب كهربائي مستمر", 55),
      C("النيوترال (البارد) متلامس ويا الأرضي", 25),
      C("القاطع خربان", 20),
    ],
    [
      "افصل الأجهزة والدوائر المشتبه بيها.",
      "إذا بعده يفصل، خلي فني يفحص التسريب.",
    ],
    "حرجة",
    "RCCB لا يقبل الرفع RCD reset",
    "لا تحاول تلغي الحماية أو تربطها مباشر.",
  ],

  [
    "home-010",
    "قاطع التسريب RCCB",
    "زر TEST مال RCCB ما يشتغل",
    "تضغط زر الاختبار بالقاطع وما يفصل.",
    "زر TEST ما يسوي شي",
    [
      C("آلية الاختبار داخل القاطع خربانة", 70),
      C("توصيل القاطع مو صحيح", 30),
    ],
    [
      "لا تعتمد على القاطع إذا زر TEST ما يشتغل.",
      "خلي فني يفحصه ويبدله إذا لازم.",
    ],
    "حرجة",
    "RCCB TEST RCD test button",
    "قاطع الحماية إذا زر الاختبار ماله ما يشتغل يعتبر مشكلة سلامة.",
  ],

  [
    "home-011",
    "قاطع التسريب RCCB",
    "قاطع التسريب يفصل من تمطر",
    "المشكلة تظهر بالمطر أو من تصير رطوبة بالمكان.",
    "القاطع يفصل ويا المطر",
    [
      C("ماي داخل ببلك سويج خارجي", 45),
      C("ماي داخل بوحدة إنارة أو علبة", 35),
      C("عزل الأسلاك متضرر", 20),
    ],
    [
      "افصل الدائرة الخارجية المتأثرة.",
      "صلح مكان دخول الماي وبدل القطع المتضررة.",
    ],
    "حرجة",
    "RCCB مطر رطوبة تسريب",
    "لا تفتح بلك سويج أو علبة كهرباء وهي مبللة.",
  ],

  [
    "home-012",
    "التمديدات",
    "النيوترال (البارد) مقطوع",
    "إذا النيوترال (البارد) انقطع أو ضعف، الإنارة والأجهزة ممكن تتصرف بشكل غريب.",
    "المصابيح تقوى وتضعف والأجهزة تتصرف مو طبيعي",
    [
      C("ربطة النيوترال (البارد) مرخية باللوحة", 50),
      C("وصلة النيوترال (البارد) محترقة", 30),
      C("أكو قطع بكابل التغذية", 20),
    ],
    [
      "افصل الأجهزة الحساسة فوراً.",
      "خلي فني يفحص النيوترال (البارد) والتغذية.",
    ],
    "حرجة",
    "فقدان النيوترال open neutral neutral",
    "فقدان النيوترال (البارد) ممكن يسبب فولت عالي على بعض الأجهزة، فلا تأخر الفحص.",
  ],

  [
    "home-013",
    "التغذية",
    "الفولت ضعيف بالبيت",
    "المصابيح تبين ضعيفة وبعض الأجهزة ما تشتغل مضبوط.",
    "ضعف عام بالكهرباء",
    [
      C("الفولت ضعيف من الشبكة", 40),
      C("كيبل التغذية مو مناسب", 30),
      C("أكو ربطة مرخية", 20),
      C("الحمل عالي", 10),
    ],
    [
      "قلل الأحمال القوية مؤقتاً.",
      "خلي فني يقيس الفولت ويفحص التغذية.",
    ],
    "عالية",
    "فولت منخفض هبوط فولتية low voltage",
    "القياس داخل اللوحة يكون بواسطة شخص يعرف يتعامل ويا الكهرباء الحية.",
  ],

  [
    "home-014",
    "التغذية",
    "الفولت عالي بالبيت",
    "المصابيح تحترق بسرعة أو بعض الأجهزة تفصل حماية.",
    "أجهزة ومصابيح تتعطل بشكل متكرر",
    [
      C("الفولت جاي عالي من الشبكة", 55),
      C("أكو مشكلة بالنيوترال (البارد)", 30),
      C("منظم الفولت أو التوصيل بيه مشكلة", 15),
    ],
    [
      "افصل الأجهزة الحساسة.",
      "خلي فني يقيس الفولت ويفحص النيوترال (البارد).",
    ],
    "حرجة",
    "فولت مرتفع overvoltage",
    "لا تخلي الأجهزة الحساسة شغالة إذا الفولت واضح عالي أو يتذبذب بقوة.",
  ],

  [
    "home-015",
    "التغذية",
    "الفولت يصعد وينزل",
    "الإنارة تقوى وتضعف وبعض الأجهزة تعيد تشغيل نفسها.",
    "تذبذب بالكهرباء",
    [
      C("الشبكة الخارجية مو مستقرة", 40),
      C("ربطة رئيسية مرخية", 35),
      C("مشكلة بالنيوترال (البارد)", 25),
    ],
    [
      "افصل الأجهزة الحساسة إذا التذبذب قوي.",
      "افحص التغذية واللوحة.",
    ],
    "عالية",
    "تذبذب فولت voltage fluctuation",
    "التذبذب القوي يحتاج فحص سريع حتى ما تتضرر الأجهزة.",
  ],

  [
    "home-016",
    "الإنارة",
    "المصابيح ترفرف",
    "المصباح يرفرف أو يومض بشكل مستمر أو بين فترة وفترة.",
    "رفرفة بالإنارة",
    [
      C("أكو ربطة مرخية", 40),
      C("درايفر LED تعبان", 35),
      C("أكو مشكلة بالنيوترال (البارد)", 25),
    ],
    [
      "جرب مصباح سليم.",
      "إذا أكثر من مصباح يرفرف، خلي فني يفحص الخط.",
    ],
    "متوسطة",
    "مصابيح تومض flicker LED",
    "إذا الرفرفة وياها ريحة حرك أو حرارة، افصل الدائرة.",
  ],

  [
    "home-017",
    "الإنارة",
    "المصابيح تضعف من يشتغل جهاز قوي",
    "من يشتغل مكيف أو مضخة أو جهاز قوي، الإنارة تضعف.",
    "الإنارة تخفت ويا الحمل",
    [
      C("يصير هبوط بالفولت", 45),
      C("التغذية ما تتحمل الحمل", 35),
      C("أكو وصلة مقاومتها عالية", 20),
    ],
    [
      "راقب إذا المشكلة تصير ويا جهاز محدد.",
      "خلي فني يفحص الحمل والتغذية.",
    ],
    "عالية",
    "انارة تخفت عند حمل كبير voltage sag",
    "إذا الهبوط قوي ومتكرر، لا تهمله.",
  ],

  [
    "home-018",
    "الإنارة",
    "مصباح واحد ما يشتغل",
    "كل الإنارة تشتغل عدا مصباح أو نقطة وحدة.",
    "مصباح واحد مطفي",
    [
      C("المصباح أو الدرايفر خربان", 55),
      C("قاعدة المصباح خربانة", 25),
      C("أكو سلك مفصول", 20),
    ],
    [
      "جرب مصباح سليم.",
      "إذا ما اشتغل، افحص القاعدة والتوصيل.",
    ],
    "منخفضة",
    "مصباح واحد لا يعمل",
    "افصل القاطع قبل فتح قاعدة المصباح.",
  ],

  [
    "home-019",
    "الإنارة",
    "مجموعة مصابيح كلها ما تشتغل",
    "أكثر من مصباح بنفس المنطقة أو الخط متوقف.",
    "مجموعة إنارة كاملة طافية",
    [
      C("قاطع الإنارة فاصل", 40),
      C("أكو قطع بأول علبة توزيع", 35),
      C("النيوترال (البارد) مقطوع", 25),
    ],
    [
      "تأكد من القاطع.",
      "إذا القاطع طبيعي، خلي فني يفحص أول نقطة تغذية.",
    ],
    "متوسطة",
    "مجموعة انارة لا تعمل lighting circuit dead",
    "فصل الدائرة قبل فتح علب التوصيل.",
  ],

  [
    "home-020",
    "الإنارة",
    "مصباح LED يبقى يضوي شوي وهو مطفي",
    "بعد ما تطفي المفتاح، يبقى نور خفيف جداً بالمصباح.",
    "المصباح بيه نور خفيف وهو مطفي",
    [
      C("أكو تيار بسيط مار من مفتاح مضيء أو مقاومة متغيرة للمصابيح", 45),
      C("أكو تأثير من الأسلاك القريبة", 30),
      C("المفتاح مربوط بطريقة مو صحيحة", 25),
    ],
    [
      "استخدم مفتاح أو مقاومة متغيرة للمصابيح مناسبة للـLED.",
      "خلي فني يراجع التوصيل إذا المشكلة مستمرة.",
    ],
    "منخفضة",
    "LED يضوي وهو مطفي ghost glow",
    "لا تغير التوصيلات وأنت مشغل الكهرباء.",
  ],

  [
    "home-021",
    "الإنارة",
    "مصابيح LED تحترق بسرعة",
    "كل فترة قصيرة تبدل المصابيح لأن تخرب بسرعة.",
    "احتراق مصابيح بشكل متكرر",
    [
      C("حرارة عالية حوالين المصباح", 35),
      C("الفولت عالي أو متذبذب", 30),
      C("نوعية الدرايفر ضعيفة", 20),
      C("أكو ربطة مرخية", 15),
    ],
    [
      "استخدم مصابيح نوعية زينة ومناسبة للمكان.",
      "افحص الفولت والتهوية إذا المشكلة مستمرة.",
    ],
    "متوسطة",
    "LED يحترق بسرعة مصابيح",
    "إذا أكثر من مصباح يخرب بنفس المكان، المشكلة ممكن مو من المصابيح نفسها.",
  ],

  [
    "home-022",
    "مفتاح الإنارة",
    "حرارة مفتاح الإنارة ترتفع",
    "تحس مفتاح الإنارة حرارته مرتفعة بشكل واضح.",
    "ارتفاع حرارة المفتاح",
    [
      C("أكو ربطة مرخية", 45),
      C("الحمل أكبر من تحمل المفتاح", 35),
      C("المفتاح نفسه خربان", 20),
    ],
    [
      "وقف استخدام المفتاح إذا حرارته عالية.",
      "بدل المفتاح أو صلح التوصيل بعد الفحص.",
    ],
    "عالية",
    "مفتاح حرارة عالية switch overheating",
    "افصل القاطع قبل فتح المفتاح.",
  ],

  [
    "home-023",
    "مفتاح الإنارة",
    "أكو شرر أو طكّة من المفتاح",
    "من تشغل أو تطفي المفتاح تسمع طكّة قوية أو تشوف شرر.",
    "شرر من المفتاح",
    [
      C("التلامسات الداخلية متآكلة", 55),
      C("أكو ربطة مرخية", 30),
      C("الحمل مو مناسب للمفتاح", 15),
    ],
    [
      "وقف استخدام المفتاح.",
      "بدله وافحص التوصيلات.",
    ],
    "عالية",
    "شرر مفتاح light switch spark",
    "إذا أكو شرر واضح، افصل القاطع فوراً.",
  ],

  [
    "home-024",
    "مقاومة متغيرة للمصابيح",
    "المقاومة المتغيرة للمصابيح تخلي المصابيح ترفرف أو تطن",
    "مصابيح LED ترفرف أو يطلع صوت من تستخدم المقاومة المتغيرة للمصابيح.",
    "رفرفة أو طنين ويا المقاومة المتغيرة للمصابيح",
    [
      C("المقاومة المتغيرة للمصابيح مو متوافقة ويا LED", 60),
      C("الحمل أقل من المطلوب", 25),
      C("درايفر المصباح مو قابل لتغيير شدة الإضاءة", 15),
    ],
    [
      "استخدم مقاومة متغيرة للمصابيح مخصصة للـLED.",
      "تأكد المصابيح نفسها قابلة لتغيير شدة الإضاءة.",
    ],
    "منخفضة",
    "مقاومة متغيرة للمصابيح LED طنين flicker dimmer",
    "اختار المقاومة المتغيرة للمصابيح حسب مواصفات المصابيح.",
  ],

  [
    "home-025",
    "بلكات سويج",
    "بلك سويج واحد ما يشتغل",
    "بلك سويج واحد ما بيه كهرباء والباقي يشتغل.",
    "بلك سويج واحد ما بيه كهرباء",
    [
      C("بلك السويج خربان", 45),
      C("أكو سلك مفصول أو مرخي وراه", 40),
      C("أكو قطع بالفرع", 15),
    ],
    [
      "وقف استخدام بلك السويج.",
      "افحص التوصيلات أو بدله.",
    ],
    "متوسطة",
    "بلك سويج لا يعمل socket outlet",
    "افصل القاطع قبل فتح بلك السويج.",
  ],

  [
    "home-026",
    "بلكات سويج",
    "كم بلك سويج بنفس المكان ما تشتغل",
    "مجموعة بلكات سويج على نفس الخط كلها ما بيها كهرباء.",
    "عدة بلكات سويج بدون كهرباء",
    [
      C("القاطع الفرعي فاصل", 40),
      C("أول بلك سويج بالخط بيه وصلة محترقة", 35),
      C("النيوترال (البارد) مقطوع", 25),
    ],
    [
      "تأكد من القاطع.",
      "خلي فني يفحص أول نقطة تغذية للخط.",
    ],
    "متوسطة",
    "بلكات سويج لا تعمل outlets dead",
    "لا تفتح بلكات السويج قبل فصل القاطع.",
  ],

  [
    "home-027",
    "بلكات سويج",
    "حرارة بلك السويج ترتفع",
    "حرارة بلك السويج أو البلكة ترتفع أثناء تشغيل الجهاز.",
    "ارتفاع حرارة بلك السويج",
    [
      C("التلامس ضعيف", 45),
      C("الحمل عالي", 35),
      C("أكو ربطة مرخية", 20),
    ],
    [
      "وقف استخدام بلك السويج فوراً.",
      "بدل بلك السويج المتضرر وافحص الحمل.",
    ],
    "عالية",
    "بلك سويج حرارة عالية socket overheating",
    "ارتفاع حرارة بلك السويج ممكن يسبب حريق، فلا تستمر باستخدامه.",
  ],

  [
    "home-028",
    "بلكات سويج",
    "بلك السويج يشرر من أدخل البلكة",
    "يطلع شرر واضح أو صوت طكّة من تدخل أو تطلع البلكة.",
    "شرر ببلك السويج",
    [
      C("بلك السويج متضرر", 45),
      C("الجهاز شغال وأنت تدخله", 30),
      C("البلكة أو سلك الجهاز متضرر", 25),
    ],
    [
      "وقف استخدام بلك السويج إذا الشرر قوي.",
      "افحص بلك السويج والبلكة.",
    ],
    "عالية",
    "شرر بلك سويج spark socket",
    "إذا أكو اسوداد أو ذوبان ببلك السويج، لازم يتبدل.",
  ],

  [
    "home-029",
    "بلكات سويج",
    "البلكة ما تثبت ببلك السويج",
    "البلكة تبقى مرخية أو تطلع بسهولة من بلك السويج.",
    "البلكة مرخية",
    [
      C("التلامسات داخل بلك السويج متآكلة", 70),
      C("بلك السويج متضرر ميكانيكياً", 30),
    ],
    [
      "بدل بلك السويج.",
    ],
    "متوسطة",
    "بلكة مرتخية loose receptacle",
    "بلك السويج المرخي يسبب حرارة وشرر، فلا تستخدمه للأحمال العالية.",
  ],

  [
    "home-030",
    "بلكات سويج",
    "بلك السويج ما بيه أرضي",
    "الكهرباء موجودة ببلك السويج بس خط الأرضي مو موجود أو مقطوع.",
    "ماكو أرضي ببلك السويج",
    [
      C("سلك الأرضي مفصول", 55),
      C("التمديد قديم وما بيه أرضي", 30),
      C("ربطة الأرضي مرخية", 15),
    ],
    [
      "خلي فني يصلح مسار الأرضي.",
      "لا تستخدمه لأجهزة جسمها معدني لحين الإصلاح.",
    ],
    "حرجة",
    "بلك سويج بدون ارضي no earth ground",
    "التأريض مهم للحماية من الصعقة، خصوصاً بالأجهزة المعدنية.",
  ],

  [
    "home-031",
    "بلكات سويج",
    "النيوترال (البارد) مقطوع ببلك السويج",
    "الفاز ممكن موجود بس الجهاز ما يشتغل لأن خط النيوترال (البارد) مقطوع.",
    "بلك السويج بيه فاز بس ما يشغل الجهاز",
    [
      C("سلك النيوترال (البارد) مفصول", 60),
      C("وصلة النيوترال (البارد) محترقة", 25),
      C("أكو قطع بالخط", 15),
    ],
    [
      "خلي الدائرة مفصولة.",
      "خلي فني يفحص مسار النيوترال (البارد).",
    ],
    "عالية",
    "open neutral socket بلك سويج",
    "لا تعتمد على مفك الفحص وحده لتشخيص المشكلة.",
  ],

  [
    "home-032",
    "بلكات سويج",
    "الفولت ينزل من أشغل جهاز على بلك السويج",
    "الفولت يكون طبيعي بدون حمل، ومن تشغل جهاز قوي ينزل.",
    "هبوط فولت من أشغل جهاز",
    [
      C("أكو وصلة مقاومتها عالية", 50),
      C("السلك نحيف أو طويل زيادة", 30),
      C("الحمل زايد على الخط", 20),
    ],
    [
      "لا تشغل حمل قوي على بلك السويج لحين الفحص.",
      "افحص التوصيلات ومقطع السلك.",
    ],
    "عالية",
    "هبوط فولت بلك سويج voltage drop",
    "قياس الهبوط تحت الحمل يفضل يسويه فني مؤهل.",
  ],

  [
    "home-033",
    "التمديدات",
    "أكو ريحة حرك طالعة من الجدار",
    "تشم ريحة بلاستك أو عازل محترق وما تعرف المصدر.",
    "ريحة حرك من الجدار",
    [
      C("أكو وصلة مخفية ترتفع حرارتها", 45),
      C("أكو كيبل متضرر", 35),
      C("أكو شرر داخلي متقطع", 20),
    ],
    [
      "افصل الدائرة المشتبه بيها.",
      "لا ترجع الكهرباء قبل تحديد مكان المشكلة.",
    ],
    "حرجة",
    "رائحة احتراق جدار wiring burning smell",
    "ريحة الحرك من التمديدات تعتبر إنذار خطر حريق.",
  ],

  [
    "home-034",
    "علب التفريع",
    "حرارة علبة التوصيل ترتفع",
    "حرارة غطاء علبة التوصيل أو المنطقة حواليها ترتفع بشكل مو طبيعي.",
    "ارتفاع حرارة علبة الكهرباء",
    [
      C("أكو ربطة مرخية", 55),
      C("الحمل عالي على الوصلة", 25),
      C("السلك أو الكونكتر متضرر", 20),
    ],
    [
      "افصل الدائرة.",
      "خلي الربطات تنعمل من جديد بشكل صحيح.",
    ],
    "عالية",
    "علبة تفريع حرارة عالية junction box",
    "لا تفتح العلبة وهي تحت الكهرباء.",
  ],

  [
    "home-035",
    "التمديدات",
    "عازل الأسلاك متشقق أو ذايب",
    "تشوف العازل ناشف أو متشقق أو ذايب.",
    "تلف واضح بعازل السلك",
    [
      C("حرارة مستمرة", 40),
      C("السلك قديم", 30),
      C("ضرر أو ضغط على السلك", 30),
    ],
    [
      "بدل الجزء المتضرر من الكيبل.",
      "عالج سبب الحرارة أو الضرر.",
    ],
    "حرجة",
    "عازل كابل تالف damaged insulation",
    "لا تعتمد على لف تيب عشوائي إذا العازل متضرر بشكل قوي.",
  ],

  [
    "home-036",
    "التمديدات",
    "أكو تسريب كهرباء بسبب الرطوبة",
    "المشكلة تظهر من يصير المكان رطب أو يدخل ماي.",
    "العطل يزيد ويا الرطوبة",
    [
      C("ماي داخل بعلبة أو أنبوب", 50),
      C("العازل متشقق", 30),
      C("قطعة خارجية مو محكمة", 20),
    ],
    [
      "افصل الدائرة.",
      "صلح مصدر الماي وبدل القطع المتضررة.",
    ],
    "حرجة",
    "تسريب رطوبة moisture leakage",
    "لا تلمس أي قطعة كهربائية مبللة وهي تحت الكهرباء.",
  ],

  [
    "home-037",
    "التمديدات",
    "أكو شورت بين الفاز والنيوترال (البارد)",
    "القاطع يفصل فوراً بسبب تلامس مباشر بين الفاز والنيوترال (البارد).",
    "القاطع يفصل مباشرة",
    [
      C("العازل متضرر", 45),
      C("أكو خطأ بالتوصيل", 30),
      C("السلك مضغوط أو داخله مسمار", 25),
    ],
    [
      "خلي الدائرة مفصولة.",
      "خلي فني يحدد مكان الشورت ويصلحه.",
    ],
    "حرجة",
    "قصر فاز نيوترال short circuit L N",
    "لا تعيد رفع القاطع مرات إذا يفصل فوراً.",
  ],

  [
    "home-038",
    "التمديدات",
    "الفاز لامس الأرضي",
    "قاطع التسريب أو القاطع يفصل بسبب تلامس الفاز ويا الأرضي.",
    "فصل حماية بسبب تسريب",
    [
      C("العازل متضرر", 50),
      C("أكو رطوبة", 25),
      C("جهاز أو قطعة كهربائية متضررة", 25),
    ],
    [
      "خلي الدائرة مفصولة.",
      "حدد مكان التسريب وصلحه.",
    ],
    "حرجة",
    "earth fault قصر فاز ارضي",
    "لا تلغي سلك الأرضي ولا قاطع التسريب حتى توقف الفصل.",
  ],

  [
    "home-039",
    "التمديدات",
    "السلك مضروب بمسمار أو مأكول من قوارض",
    "السلك انجرح أو انقطع بسبب حفر أو مسمار أو قوارض.",
    "العطل ظهر بعد حفر أو أكو تلف بالسلك",
    [
      C("مسمار أو برغي داخل بالكيبل", 45),
      C("قوارض ماكلة العازل", 35),
      C("السلك متعرض لضغط أو شد", 20),
    ],
    [
      "بدل الجزء المتضرر من السلك.",
      "احمِ مسار الكيبل حتى ما تتكرر المشكلة.",
    ],
    "حرجة",
    "مسمار كابل قوارض damaged cable",
    "إذا تشك إن مسمار داخل بالسلك، لا تلمس المسمار قبل فصل الكهرباء.",
  ],

  [
    "home-040",
    "أسلاك التمديد",
    "حرارة سلك التمديد ترتفع أو يذوب",
    "حرارة السلك أو البلكة مال التمديد ترتفع من الاستخدام.",
    "ارتفاع حرارة سلك التمديد",
    [
      C("السلك أرفع من الحمل المطلوب", 45),
      C("البكرة ملفوفة والحمل عالي", 30),
      C("البلكة أو الوصلة ضعيفة", 25),
    ],
    [
      "وقف استخدام السلك.",
      "استخدم تمديد مناسب للحمل.",
    ],
    "عالية",
    "extension cord overheating سلك تمديد",
    "إذا العازل ذايب أو متغير لونه، بدل السلك ولا تستخدمه.",
  ],

  [
    "home-041",
    "المشتركات",
    "حرارة المشترك الكهربائي ترتفع",
    "حرارة المشترك أو البلكة مالتَه ترتفع من توصل عليه أجهزة.",
    "ارتفاع حرارة المشترك",
    [
      C("الحمل أعلى من تحمله", 55),
      C("التلامسات الداخلية ضعيفة", 25),
      C("البلكة أو بلك السويج متضرر", 20),
    ],
    [
      "قلل الأجهزة المربوطة عليه.",
      "بدله إذا بيه حرارة قوية أو آثار حرك.",
    ],
    "عالية",
    "power strip overheating مشترك",
    "لا تربط سخان أو حمل قوي على مشترك مو مخصص له.",
  ],

  [
    "home-042",
    "الأجهزة المعدنية",
    "الجهاز يكهرب من ألمس جسمه",
    "تحس بلسعة أو صعقة من جسم جهاز معدني.",
    "لسعة كهرباء من الجهاز",
    [
      C("أكو تسريب داخل الجهاز", 50),
      C("الأرضي مقطوع", 30),
      C("أكو رطوبة أو عزل متضرر", 20),
    ],
    [
      "افصل الجهاز فوراً.",
      "لا تستخدمه لحد ما ينفحص.",
    ],
    "حرجة",
    "صعقة جهاز جسم معدني electric shock appliance",
    "لا تلمس الجهاز مرة ثانية حتى تجربه. افصله من مصدر آمن وخلي فني يفحصه.",
  ],

  [
    "home-043",
    "السخان الكهربائي",
    "السخان يفصل قاطع التسريب",
    "من تشغل السخان، RCCB يفصل.",
    "قاطع التسريب يفصل ويا السخان",
    [
      C("الهيتر يسرب كهرباء", 60),
      C("أكو رطوبة بالتوصيلات", 25),
      C("العزل الداخلي متضرر", 15),
    ],
    [
      "وقف استخدام السخان.",
      "خلي فني يفحص الهيتر والتأريض.",
    ],
    "حرجة",
    "سخان يفصل RCCB water heater earth leakage",
    "السخان والماء والكهرباء خطر جداً، فلا تستخدمه قبل الفحص.",
  ],

  [
    "home-044",
    "الغسالة",
    "الغسالة تفصل قاطع التسريب",
    "RCCB يفصل من تشغل الغسالة أو توصلها.",
    "القاطع يفصل ويا الغسالة",
    [
      C("تسريب من الهيتر أو الماطور", 45),
      C("أكو رطوبة داخل الغسالة", 30),
      C("السلك أو فلتر الدخول متضرر", 25),
    ],
    [
      "افصل الغسالة.",
      "خلي فني أجهزة يفحصها.",
    ],
    "حرجة",
    "غسالة تفصل RCCB washing machine leakage",
    "لا تستخدم الغسالة إذا قاطع التسريب يفصل بسببها.",
  ],

  [
    "home-045",
    "الثلاجة",
    "القاطع يفصل من تشتغل الثلاجة",
    "من يحاول الكمبريسر يشتغل، القاطع يفصل.",
    "الفصل يصير ويا بداية الكمبريسر",
    [
      C("أكو خلل بالكمبريسر أو ريليه التشغيل", 45),
      C("السلك أو البلكة متضررة", 30),
      C("الدائرة ما تتحمل الحمل", 25),
    ],
    [
      "افصل الثلاجة.",
      "خلي فني يفحص الكمبريسر والدائرة.",
    ],
    "عالية",
    "ثلاجة تفصل قاطع refrigerator breaker trip",
    "لا تبدل القاطع بأمبير أعلى حتى تحل المشكلة.",
  ],

  [
    "home-046",
    "المكيف المنزلي",
    "حرارة بلك السويج أو خط المكيف ترتفع",
    "حرارة البلكة أو بلك السويج أو سلك التغذية ترتفع أثناء تشغيل المكيف.",
    "ارتفاع حرارة تغذية المكيف",
    [
      C("التلامس ضعيف", 40),
      C("السلك مو مناسب للحمل", 35),
      C("الحمل أو القاطع مو مناسب", 25),
    ],
    [
      "وقف المكيف.",
      "خلي فني يفحص الخط وبلك السويج والقاطع.",
    ],
    "حرجة",
    "مكيف بلك سويج حرارة عالية AC outlet overheating",
    "ارتفاع حرارة خط المكيف ممكن يسبب حريق، فلا تستمر بتشغيله.",
  ],

  [
    "home-047",
    "بلكات سويج الخارجية",
    "بلك السويج الخارجي يفصل من تمطر",
    "بعد المطر بلك السويج يتوقف أو قاطع التسريب يفصل.",
    "المشكلة تظهر بعد المطر",
    [
      C("ماي داخل ببلك السويج", 55),
      C("الغطاء مو محكم", 25),
      C("كيبل التغذية متضرر", 20),
    ],
    [
      "افصل الدائرة الخارجية.",
      "بدل بلك السويج أو الغطاء إذا متضرر.",
    ],
    "حرجة",
    "بلك سويج خارجي مطر outdoor socket rain",
    "لا تفتح بلك السويج وهو مبلل.",
  ],

  [
    "home-048",
    "جرس الباب",
    "جرس الباب ما يشتغل",
    "تضغط الزر وماكو صوت.",
    "الجرس ساكت",
    [
      C("زر الجرس خربان", 40),
      C("محولة الجرس خربانة", 35),
      C("سلك الجرس مقطوع", 25),
    ],
    [
      "افحص زر الجرس.",
      "افحص المحولة والأسلاك.",
    ],
    "منخفضة",
    "جرس باب لا يعمل doorbell",
    "إذا المحولة مربوطة على 220 فولت، خلي الفحص لفني.",
  ],

  [
    "home-049",
    "مروحة السقف",
    "مروحة السقف ما تشتغل",
    "تشغل المفتاح بس المروحة ما تدور.",
    "المروحة متوقفة",
    [
      C("المكثف خربان", 40),
      C("المفتاح أو منظم السرعة خربان", 30),
      C("الماطور أو التوصيل بيه مشكلة", 30),
    ],
    [
      "افحص المنظم والمكثف.",
      "إذا الماطور يطن وما يدور، لا تخليه شغال.",
    ],
    "متوسطة",
    "مروحة سقف لا تعمل ceiling fan",
    "افصل القاطع قبل فتح المروحة أو المنظم.",
  ],

  [
    "home-050",
    "مروحة السقف",
    "مروحة السقف بطيئة أو تطن",
    "المروحة تدور ببطء أو تسمع منها طنين.",
    "سرعة ضعيفة أو طنين",
    [
      C("المكثف ضعيف", 55),
      C("أكو احتكاك ميكانيكي", 25),
      C("الفولت ضعيف أو التوصيل مو زين", 20),
    ],
    [
      "افحص المكثف والمنظم.",
      "افحص حركة المروحة والفولت.",
    ],
    "متوسطة",
    "مروحة بطيئة طنين ceiling fan slow",
    "إذا حرارة الماطور مرتفعة أو يطن بدون ما يدور، طفّه حتى ما يحترك.",
  ],
];

export const homeFaults: HomeFault[] =
  rows.map(
    ([
      id,
      device_ar,
      name_ar,
      description_ar,
      symptom,
      causes,
      solutions,
      severity,
      keywords,
      check,
    ]) => {
      const critical =
        severity === "حرجة";

      return {
        id,
        category_id: null,
        device_ar,
        name_ar,
        description_ar,
        symptoms: [symptom],
        causes,
        tests: [
          {
            test: "الفحص الأولي",
            location: device_ar,
            method: check,
            normal:
              "كلشي طبيعي، ماكو حرك ولا حرارة عالية ولا أسلاك متضررة، والجزء يشتغل طبيعي.",
            faulty:
              "أكو حرارة عالية أو حرك أو قطع أو ربطة مرخية أو فصل متكرر، وهنا يحتاج إصلاح.",
          },
        ],
        solutions,
        severity,
        safety_warnings: critical
          ? [
              "تنبيه: أكو احتمال صعقة أو حريق. افصل الكهرباء من مكان آمن ولا تلمس أي سلك مكشوف.",
              "فتح اللوحة أو القياس على كهرباء حية خليه لفني كهربائي يعرف شيسوي.",
            ]
          : [
              "افصل الكهرباء قبل ما تفتح أو تفك أي شي.",
              "إذا شفت شرر أو ذوبان أو شميت ريحة حرك، لا ترجع تشغل الدائرة قبل الإصلاح.",
            ],
        error_code: null,
        keywords,
        next_question_key: null,
      };
    },
  );